import { ThirdParty } from "project-config/constants/third-party";

export enum BindOperate {
  Cancel,
  Bind,
}
export enum BindStatus {
  UnBound,
  Bound,
}
export enum Operate {
  Bind = "bind",
  Cancel = "cancel",
}
export const JUMP_LINKS: { [key in ThirdParty]?: string } = {
  [ThirdParty.WeChat]: "/sso/passport?business=wechat",
  [ThirdParty.QQ]: "/sso/passport?business=qq",
};
export const MINI_PROGRAM_DIALOG_TITLE = {
  [Operate.Bind]: "user_binded_bind_title",
  [Operate.Cancel]: "user_binded_cancel_title",
};
export const MINI_PROGRAM_DIALOG_MESSAGE = {
  [Operate.Bind]: "user_binded_bind_message",
  [Operate.Cancel]: "user_binded_cancel_message",
};
export const MINI_PROGRAM_DIALOG_TIPS = {
  [Operate.Bind]: "user_binded_bind_hint",
  [Operate.Cancel]: "user_binded_cancel_hint",
};
export const MINI_PROGRAM_OPERATE_TYPE = {
  [Operate.Bind]: BindOperate.Bind,
  [Operate.Cancel]: BindOperate.Cancel,
};
export const UNBIND_DIALOG_TITLE = {
  [ThirdParty.WeChat]: "user_binded_unbind_title_0",
  [ThirdParty.MiniProgram]: "user_binded_unbind_title_1",
  [ThirdParty.QQ]: "user_binded_unbind_title_2",
};
export const UNBIND_DIALOG_MESSAGE = {
  [ThirdParty.WeChat]: "user_binded_unbind_message_0",
  [ThirdParty.MiniProgram]: "user_binded_unbind_message_1",
  [ThirdParty.QQ]: "user_binded_unbind_message_2",
};
